import { useCallback } from 'react';
import { useCustomMutation } from './core/useCustomMutation';
import { generateNextHomeworkHelp } from '../../services/api/wr-tools/generateNextHomeworkHelp';
import { useAuthContext } from '../auth/useAuthContext';
import { useEditorContext } from '../editor/useEditorContext';

export const useGenerateNextHomeworkHelp = () => {
  const {
    userHomeworkHelpNextRequest,
    generationChatId,
    EditorActionCreator,
    editorDispatch,
  } = useEditorContext();
  const { clientHash } = useAuthContext();

  const { error, isLoading, isSuccess, mutateAsync } = useCustomMutation(
    generateNextHomeworkHelp,
    {
      onSuccess: (response) => {
        if (response?.data) {
          editorDispatch(
            EditorActionCreator.setGenerationText(
              response.data.generatedText || ''
            )
          );
          editorDispatch(
            EditorActionCreator.setGenerationId(
              response.data.responseGenIdHash || ''
            )
          );
          editorDispatch(
            EditorActionCreator.setUserHomeworkHelpNextRequest('')
          );
        }
      },
      retry: 2,
    }
  );

  const generateNextHomeworkHelpMutation = useCallback(
    (currentRequest?: string) =>
      mutateAsync({
        clientHash,
        chatIdHash: generationChatId,
        instructions: currentRequest || userHomeworkHelpNextRequest,
      }),
    [clientHash, generationChatId, mutateAsync, userHomeworkHelpNextRequest]
  );

  return {
    error,
    isTextGenerating: isLoading,
    isTextGenerationSuccess: isSuccess,
    generateNextHomeworkHelpMutation,
  };
};
